import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Checkbox, Dialog } from '@shared/components';
import CircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';

const noop = () => {};
const ActionDialog = ({
  classes = {},
  content = null,
  contentText = 'Are you sure you want to perform this operation?',
  contentVariant = 'body1',
  hasClose = true,
  hasPreferenceCheck = false,
  heading = '',
  isConfirmation = false,
  negativeActionLabel = 'Cancel',
  onCancel = noop,
  onClose = null,
  onConfirm = noop,
  open = false,
  onPreferenceChange = noop,
  positiveActionLabel,
  preferenceChecked = false,
  preferenceLabel = 'Don’t show me this again.',
  isConfirmDisabled = false,
  isLoading = false,
}) => {
  if (!positiveActionLabel) {
    if (isConfirmation) {
      positiveActionLabel = 'Confirm';
    } else {
      positiveActionLabel = 'Ok';
    }
  }
  const dialogClasses = React.useMemo(() => {
    const dialogClasses = { ...classes };
    delete dialogClasses.confirm;
    delete dialogClasses.cancel;
    delete dialogClasses.content;
    delete dialogClasses.preferenceWrapper;
    delete dialogClasses.preferenceLabel;
    delete dialogClasses.checkbox;
    return dialogClasses;
  }, [classes]);

  return (
    <Dialog
      classes={{
        ...dialogClasses,
        paper: `${dialogClasses.paper} ${
          isConfirmation ? 'confirmation-dialog' : 'info-dialog'
        }`,
      }}
      open={open}
      onClose={onClose || onCancel}
      centered
      data-testid='action-dialog-wrapper'
    >
      <Dialog.Title hasClose={hasClose} />
      <Dialog.Content>
        {content ? (
          <>{content}</>
        ) : (
          <>
            <div>{heading}</div>
            <div
              className={clsx(
                classes.content,
                'd-flex flex-column f-justify-between h-100 color-text-secondary mt-8'
              )}
            >
              <Typography variant={contentVariant}>{contentText}</Typography>
              {hasPreferenceCheck && (
                <div
                  className={clsx(
                    classes.preferenceWrapper,
                    'd-flex f-align-center mt-5'
                  )}
                >
                  <Checkbox
                    className={clsx(classes.checkbox, 'mr-3')}
                    checked={preferenceChecked}
                    onChange={onPreferenceChange}
                  />
                  <Typography
                    className={classes.preferenceLabel}
                    variant='body1'
                  >
                    {preferenceLabel}
                  </Typography>
                </div>
              )}
            </div>
          </>
        )}
      </Dialog.Content>
      <Dialog.Actions>
        {((isConfirmation && onCancel && onCancel !== noop) ||
          (onCancel && onCancel !== noop)) && (
          <Button
            className={clsx(classes.cancel, 'm-4')}
            onClick={onCancel}
            variant='outlined'
          >
            {/* <Typography variant='body2'>{negativeActionLabel}</Typography> */}
            {negativeActionLabel}
          </Button>
        )}
        <Button
          className={clsx(classes.confirm, 'm-4')}
          color='secondary'
          disableElevation
          onClick={onConfirm}
          variant='contained'
          disabled={isConfirmDisabled || isLoading}
        >
          {/* <Typography variant='body2'>{positiveActionLabel}</Typography> */}
          {positiveActionLabel}
          {isLoading && (
            <CircularProgress size={24} className='p-absolute color-grey' />
          )}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default ActionDialog;
